import React from 'react';
import { Box, Typography, Card, CardMedia, CardContent, IconButton, Modal } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useState, useEffect } from 'react';
import ProductDetails from '../Product/Body/ProductDetails';

// Sample staff picks data
const NEW_ARRIVALS = [
  {
    id: 'staff-1',
    images: [
      "https://cdn.shopify.com/s/files/1/0806/1239/3254/files/3_af548046-e3f2-433e-9946-d5f8c312056c.jpg?v=1758216051",
      "https://cdn.shopify.com/s/files/1/0806/1239/3254/files/1.jpg?v=1758216051",
      "https://cdn.shopify.com/s/files/1/0806/1239/3254/files/2.jpg?v=1758216051"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0806/1239/3254/files/3_af548046-e3f2-433e-9946-d5f8c312056c.jpg?v=1758216051",
    brand: "Reyna Signature",
    title: "For The Kingdom Tee",
    price: "55.00",
    originalPrice: "55.00",
    productType: "T-shirt",
    link: "https://reynasignature.com/products/for-the-kingdom-tee"
  },
  {
    id: 'staff-2',
    images: [
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-621578.jpg?v=1746711705",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-484929.png?v=1746711705",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-740692.png?v=1746711705",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-841348.jpg?v=1736778514",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-797385.jpg?v=1736778514",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-972153.jpg?v=1736778514",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-874990.jpg?v=1736778514",
      "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-321043.jpg?v=1736778514"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/1034/6643/files/rob-hell-tee-cream-621578.jpg?v=1746711705",
    brand: "Native Supply",
    title: "Rob Hell Tee (Cream) Test",
    price: "45.00",
    originalPrice: "45.00",
    productType: "T-shirt",
    link: "https://native.supply/collections/all/products/rob-hell-tee-cream-test"
  },
  {
  id: 'staff-3',
  images: [
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_01_b9d90683-38d4-4ad8-b9ae-ee65d0f3f449.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_02_66f57df4-aa71-454b-81d4-07a3a5ba9197.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_03_02ddbd45-d5d1-4729-93f0-b670270e815c.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_04_69333804-a48f-4a04-884b-547ba38baef5.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_05_6b574056-d990-4fcd-8e89-ba01fa70dde0.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_06_9c7cc65b-c900-4200-bb2c-49a0200c18d3.jpg?v=1759871048",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_01_28cb514b-7499-4f80-9882-33a474d957f3.jpg?v=1759871062",
      "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_02_0f3c1bb9-ba47-4df3-80fd-c1dfead01cd2.jpg?v=1759871062"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0956/3508/files/Spirit-Is-Moving-LS-Heavyweight-Tee_01_b9d90683-38d4-4ad8-b9ae-ee65d0f3f449.jpg?v=1759871048",
    brand: "Elevated Faith",
    title: "Spirit Is Moving LS Heavyweight Tee",
    price: "49.99",
    originalPrice: null,
    productType: "T-shirt",
    link: "https://elevatedfaith.com/products/spirit-is-moving-ls-heavyweight-unisex-tee"
  },
  {
    id: 'staff-4',
    images: [
      "https://cdn.shopify.com/s/files/1/2468/1631/files/fn_front_c5d23f1f-b82f-43ec-8c2a-e1ba2b854ccc.png?v=1729612410",
      "https://cdn.shopify.com/s/files/1/2468/1631/files/fn_back_1b2f4c9e-7317-459e-9470-715742b202aa.png?v=1729612401"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/2468/1631/files/fn_front_c5d23f1f-b82f-43ec-8c2a-e1ba2b854ccc.png?v=1729612410",
    brand: "IV His Glory",
    title: "Fear Not Hoodie",
    price: "50.00",
    originalPrice: null,
    productType: "Hoodie",
    link: "https://ivhisglory.com/products/fear-not"
  },
  {
    id: 'staff-5',
    images: [
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/D7512602-A229-4153-8CAD-1E6DBC3CA6B3.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-white-front-68ccc7d16fea2.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-white-back-68ccc7d183174.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-black-front-68ccc7d07adc8.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-black-back-68ccc7d07b94c.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-dark-chocolate-front-68ccc7d075a0c.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-dark-chocolate-back-68ccc7d0824e8.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-indigo-blue-front-68ccc7d0afbe5.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-indigo-blue-back-68ccc7d0b9a92.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-navy-front-68ccc7d07cc5a.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-navy-back-68ccc7d07f354.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-light-blue-front-68ccc7d0db93b.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-light-blue-back-68ccc7d0e9dee.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-light-pink-front-68ccc7d120869.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-light-pink-back-68ccc7d1304a7.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-military-green-front-68ccc7d0c4661.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-military-green-back-68ccc7d0cf789.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-sand-front-68ccc7d103854.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-sand-back-68ccc7d1119f7.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-charcoal-front-68ccc7d0978ec.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-charcoal-back-68ccc7d0a01f2.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-ash-front-68ccc7d141ae7.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-ash-back-68ccc7d156b46.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-forest-green-front-68ccc7d087f04.jpg?v=1759966261",
      "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/unisex-crew-neck-sweatshirt-forest-green-back-68ccc7d090067.jpg?v=1759966261"
    ],
    imageUrl: "https://cdn.shopify.com/s/files/1/0566/4866/3199/files/D7512602-A229-4153-8CAD-1E6DBC3CA6B3.jpg?v=1759966261",
    brand: "God above all ✞",
    title: "THROUGH CHRIST ALONE CREWNECK",
    price: "59.99",
    originalPrice: null,
    productType: "Crewneck",
    link: "https://godaboveall.ca/products/through-christ-alone-crewneck-1"
  }
];

export default function NewArrivals() {
  return (
    <Box sx={{ mx: 1.5}}>
      {/* Section Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          px: 1,
          textAlign: 'left',
          color: '#333'
        }}
      >
        New Arrivals
      </Typography>

      {/* Horizontal Scrollable Container */}
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          pb: 2,
          scrollbarWidth: 'none', // Hide scrollbar for Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Hide scrollbar for Webkit browsers
          },
        }}
      >
        {NEW_ARRIVALS.map((product) => (
          <NewArrivalCard key={product.id} product={product} />
        ))}
      </Box>
    </Box>
  );
}

// Individual staff pick card component
function NewArrivalCard({ product }) {
  const { imageUrl, discount, brand, title, price, originalPrice } = product;
  const [liked, setLiked] = useState(false);
  const [open, setOpen] = useState(false); // State to track if the modal is open

  // Check localStorage for liked state on component mount
  useEffect(() => {
    const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];
    const alreadyLiked = likedItems.some(item => item.title === title);
    setLiked(alreadyLiked);
  }, [title]);

  const handleLike = (e) => {
    e.stopPropagation();
    const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];

    if (liked) {
      // Remove from liked
      const updatedLikedItems = likedItems.filter(
        (item) => item.id !== product.id && item.title !== product.title
      );
      localStorage.setItem('likedItems', JSON.stringify(updatedLikedItems));
      setLiked(false);
    } else {
      // Add to liked if not already present
      const alreadyExists = likedItems.some(
        (item) => item.id === product.id || item.title === product.title
      );
      if (!alreadyExists) {
        likedItems.push(product);
        localStorage.setItem('likedItems', JSON.stringify(likedItems));
      }
      setLiked(true);
    }
  };

  return (
    <>
    <Card
      onClick={() => setOpen(true)} // Open modal on click
      sx={{
        minWidth: 200,
        maxWidth: 200,
        height: 275,
        cursor: 'pointer',
        position: 'relative',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        borderRadius: 2,
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        }
      }}
    >
            {/* Discount Badge */}
      {/* {discount && (
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: 'rgba(141, 140, 140, 0.8)',
            color: 'white',
            borderRadius: 1,
            px: 1,
            py: 0.5,
            fontSize: '0.7rem',
            fontWeight: 'bold',
            zIndex: 1,
          }}
        >
          {discount}% off
        </Box>
      )} */}

      {/* Like Button */}
      {/* <IconButton
        onClick={handleLike}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          }
        }}
        size="small"
      >
        {liked ? (
          <FavoriteIcon sx={{ fontSize: 16, color: 'red' }} />
        ) : (
          <FavoriteBorderIcon sx={{ fontSize: 16, color: 'white' }} />
        )}
      </IconButton> */}

      {/* Product Image */}
      <CardMedia
        component="img"
        image={imageUrl}
        alt={title}
        sx={{
          height: 180,
          objectFit: 'cover',
        }}
      />

      {/* Product Details */}
      <CardContent sx={{ pt: 1.5, mb: 0 }}>
        <Typography
          sx={{
            color: 'gray',
            fontWeight: 'bold',
            fontSize: '0.7rem',
            mb: 1,
            textAlign: 'left',
          }}
        >
          {brand}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.9rem',
            lineHeight: 1.2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            mt: 1,
            textAlign: 'left',
          }}
        >
          {title.length > 17 ? `${title.substring(0, 17)}...` : title}
        </Typography>

        {/* Price and Like Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
            ${price}
          </Typography>
          {/* {originalPrice && originalPrice !== price && (
            <Typography
              variant="caption"
              sx={{
                textDecoration: 'line-through',
                color: 'gray',
                fontSize: '0.7rem',
              }}
            >
              ${originalPrice}
            </Typography>
          )} */}
          <IconButton
            onClick={handleLike}
            sx={{
              padding: 0.5,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              zIndex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              }
            }}
            size="small"
          >
            {liked ? (
              <FavoriteIcon sx={{ fontSize: 16, color: 'red' }} />
            ) : (
              <FavoriteBorderIcon sx={{ fontSize: 16, color: 'gray' }} />
            )}
          </IconButton>
        </Box>
      </CardContent>
          {/* Product Details Modal */}
    <Modal open={open} onClose={() => setOpen(false)} disableScrollLock={false}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          width: '80%',
          maxHeight: '95vh',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <ProductDetails
          product={product}
          onClose={() => setOpen(false)}
          onLikeChange={() => {
            // Refresh liked state when modal closes
            const likedItems = JSON.parse(localStorage.getItem('likedItems')) || [];
            const alreadyLiked = likedItems.some(item => item.title === title);
            setLiked(alreadyLiked);
          }}
        />
      </Box>
    </Modal>
    </Card>


    </>
    
  );
}